import { AxiosResponse } from 'axios';
import React from 'react';
import { Observable } from 'rxjs';
import { EndpointDTO } from 'src/components/types';
import { QrCodeResponseDTO } from 'src/pages/login/types';
import {
  GuslUser,
  JWTTokens,
  SessionContextProps,
  SessionStatus,
  SignInResponseDTO,
  SignOutResponseDTO,
} from './types';

const createDefault = (): SessionContextProps => ({
  hasNoSession: (): boolean => {
    return true;
  },

  clearSession: (): void => {},

  getJwtSession: () => {
    return {};
  },

  setJwtSession: (_tokens: JWTTokens) => {},

  isJwt: (): boolean => {
    return false;
  },

  preSignIn: (): Promise<SignInResponseDTO> => {
    return new Promise<SignInResponseDTO>((resolve) => resolve({} as SignInResponseDTO));
  },
  signIn: (): Promise<SignInResponseDTO> => {
    return new Promise<SignInResponseDTO>((resolve) => resolve({} as SignInResponseDTO));
  },
  signIWithNewPassword: (): Promise<SignInResponseDTO> => {
    return new Promise<SignInResponseDTO>((resolve) => resolve({} as SignInResponseDTO));
  },
  forgotPassword: (): Promise<SignInResponseDTO> => {
    return new Promise<SignInResponseDTO>((resolve) => resolve({} as SignInResponseDTO));
  },
  getQrCode: (): Promise<QrCodeResponseDTO> => {
    return new Promise<QrCodeResponseDTO>((resolve) => resolve({} as QrCodeResponseDTO));
  },
  verifyTotp: (): Promise<unknown> => {
    return new Promise<unknown>((resolve) => resolve({}));
  },
  watchLogin: (): Observable<GuslUser | null> => {
    return new Observable<GuslUser | null>((observer) => {
      observer.complete();
    });
  },
  getLoggedInUser: () => {
    return {
      id: '',
      email: '',
      avatar: '',
    };
  },
  watchSystemReady: (): Observable<boolean> => {
    return new Observable<boolean>((observer) => {
      observer.complete();
    });
  },
  watchSessionStatus: (): Observable<SessionStatus> => {
    return new Observable<SessionStatus>((observer) => {
      observer.complete();
    });
  },

  get: <_Request, Response>(
    url: string,
    controller?: AbortController,
  ): Promise<AxiosResponse<Response>> => {
    return new Promise<AxiosResponse<Response>>((_resolve, reject) => {
      reject('not configured' + url + controller);
    });
  },

  _delete: <_Request, Response>(
    url: string,
    controller?: AbortController,
  ): Promise<AxiosResponse<Response>> => {
    return new Promise<AxiosResponse<Response>>((_resolve, reject) => {
      reject('not configured' + url + controller);
    });
  },

  post: <Request, Response>(
    url: string,
    body?: Request,
    controller?: AbortController,
  ): Promise<AxiosResponse<Response>> => {
    return new Promise<AxiosResponse<Response>>((_resolve, reject) => {
      reject('not configured' + url + body + controller);
    });
  },
  upload: <Request, Response>(
    url: string,
    body?: Request,
    controller?: AbortController,
  ): Promise<AxiosResponse<Response>> => {
    return new Promise<AxiosResponse<Response>>((_resolve, reject) => {
      reject('not configured' + url + body + controller);
    });
  },

  put: <Request, Response>(
    url: string,
    body?: Request,
    controller?: AbortController,
  ): Promise<AxiosResponse<Response>> => {
    return new Promise<AxiosResponse<Response>>((_resolve, reject) => {
      reject('not configured' + url + body + controller);
    });
  },

  sendRequest: <Request, Response>(
    endpoint: EndpointDTO,
    body?: Request,
    controller?: AbortController,
  ): Promise<AxiosResponse<Response>> => {
    return new Promise<AxiosResponse<Response>>((_resolve, reject) => {
      reject('not configured' + endpoint + body + controller);
    });
  },
  signOut: (): Promise<SignOutResponseDTO> => {
    return new Promise<SignOutResponseDTO>((resolve) =>
      resolve({ success: false } as SignOutResponseDTO),
    );
  },
  setOriginalPath: () => {},
  getOriginalPath: (): string => {
    return '';
  },
  hasPermission: (): boolean => {
    return true;
  },
  hasStrictPermission: (): boolean => {
    return true;
  },
  isProduction: (): boolean => {
    return true;
  },
});

export const SessionContext = React.createContext<SessionContextProps>(createDefault());
